
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2019-developer-survey-results",
      function () {
        return require("private-next-pages/blog/2019-developer-survey-results.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2019-developer-survey-results"])
      });
    }
  